<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" key="app_is_keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" key="app_no_keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue